import styled from '@emotion/styled/macro';
import { Link } from 'react-router-dom';
import { Flex } from '@chakra-ui/react';
import theme from 'ui/theme/theme';

export const Header = styled.header`
  background-color: ${theme.colors.gray['50']};
  margin: 0 0;
`;

export const LogoLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 4px;
`;

export const CloseLink = styled(Link)`
  height: 24px;
  align-items: center;
`;

export const EditCartLink = styled(Link)`
  flex: none;
  span {
    color: ${theme.colors.semantics.info};
  }
`;

export const StyledFlex = styled(Flex)`
  display: inline-flex;
  align-items: center;
`;

export const Container = styled(Flex)`
  align-items: center;
  width: 100%;
`;

export const BreadcrumbContainer = styled(Flex)`
  align-items: center;
  padding: 8px 0px;
  margin-top: 8px;
  width: 100%;
  overflow: auto;
  @media screen and (min-width: ${theme.breakpoints.lg}) {
    margin: 0px 12px;
  }
`;
